const NotificationGetter = {
  emails: (state) => state.emails,
  sms: (state) => state.sms,
  ads: (state) => state.ads,
  messages: s => s.messages,
  chatAvatar: s => localStorage.getItem("chatAvatar") || s.chatAvatar
};

export default NotificationGetter;
